import { Modal } from "@vesatogo/grass-core"
import {
  HistoryColumns,
  TransactionHistory,
} from "~/components/Transaction/TransactionHistory"

export type TransactionHistoryProps = {
  isOpen: boolean
  onClose: () => void
  transactions: any[]
}

export const TransactionHistoryModal: React.FC<TransactionHistoryProps> = ({
  isOpen,
  onClose,
  transactions,
}) => {
  const columns = [
    HistoryColumns.DATE.accessor,
    HistoryColumns.ACCOUNT_HOLDER_NAME.accessor,
    HistoryColumns.ACCOUNT_NO.accessor,
    HistoryColumns.PAYMENT_MODE.accessor,
    HistoryColumns.TRANSACTION_ID.accessor,
    HistoryColumns.RELEASED_AMOUNT.accessor,
  ]

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Transaction Records"
      bodyClassName="max-w-6xl overflow-visible"
    >
      <TransactionHistory transactions={transactions} columns={columns} />
    </Modal>
  )
}
